import PasswordStrengthCalculator from './PasswordStrengthCalculator';
const document = window.document;
export default class SfRegister {
    constructor() {
        this.loading = false;
        this.ajaxEndpoint = '/index.php?ajax=sf_register';
        this.ajaxRequest = null;
        this.passwordStrengthCalculator = null;
        this.form = null;
        this.barGraph = null;
        this.zone = null;
        this.zoneEmpty = null;
        this.zoneLoading = null;
        this.fileInformation = null;
        this.removeImage = null;
        if (document.readyState === 'loading') {
            // Attach content loaded element with callback to document
            document.addEventListener('DOMContentLoaded', () => this.initialize());
        }
        else {
            this.initialize();
        }
    }
    /**
     * Callback after content was loaded
     */
    initialize() {
        this.initializeElements();
        this.initializePasswordStrengthCalculator();
        this.initializeEvents();
    }
    initializeElements() {
        this.form = document.getElementById('sfrForm');
        this.zone = document.getElementById('sfrZone');
        this.zoneEmpty = document.getElementById('sfrZone_empty');
        this.zoneLoading = document.getElementById('sfrZone_loading');
        this.barGraph = document.getElementById('bargraph');
        this.fileInformation = document.getElementById('uploadFile');
        this.removeImage = document.getElementById('removeImage');
    }
    initializePasswordStrengthCalculator() {
        if (this.barGraph !== null) {
            this.barGraph.classList.add('show');
            this.passwordStrengthCalculator = new PasswordStrengthCalculator();
        }
    }
    initializeEvents() {
        this.attachToElementById('sfrCountry', 'change', (event) => this.countryChanged(event));
        this.attachToElementById('sfrCountry', 'keyup', (event) => this.countryChanged(event));
        this.attachToElementById('uploadButton', 'change', (event) => this.uploadFile(event));
        this.attachToElementById('removeImageButton', 'click', () => this.removeFile());
        this.attachToElementById('sfrPassword', 'keyup', (event) => this.checkPasswordOnChange(event));
    }
    /**
     * Add class d-block remove class d-none
     */
    showElement(element) {
        element.classList.remove('d-none');
        element.classList.add('d-block');
    }
    /**
     * Add class d-none remove class d-block
     */
    hideElement(element) {
        element.classList.remove('d-block');
        element.classList.add('d-none');
    }
    attachToElementById(id, eventName, callback) {
        const element = document.getElementById(id);
        if (element !== null) {
            this.attachToElement(element, eventName, callback);
        }
    }
    attachToElement(element, eventName, callback) {
        if (element) {
            element.addEventListener(eventName, callback);
        }
    }
    /**
     * Gets password meter element and sets the value with
     * the result of the calculate password strength function
     */
    checkPasswordOnChange(event) {
        const element = event.target, meterResult = this.passwordStrengthCalculator.calculate(element.value);
        this.barGraph.value = meterResult.score;
    }
    loadCountryZonesByCountry(countrySelectedValue) {
        if (this.zone !== null) {
            this.loading = true;
            this.zone.disabled = true;
            this.hideElement(this.zoneEmpty);
            this.showElement(this.zoneLoading);
            this.ajaxRequest = new XMLHttpRequest();
            this.ajaxRequest.onload = (event) => this.xhrReadyOnLoad(event);
            this.ajaxRequest.open('POST', this.ajaxEndpoint);
            this.ajaxRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            this.ajaxRequest.send('tx_sfregister[action]=zones&tx_sfregister[parent]=' + countrySelectedValue);
        }
    }
    /**
     * Change value of zone select box
     */
    countryChanged(event) {
        if (this.loading !== true
            && ((event instanceof KeyboardEvent && (event.key === 'ArrowDown' || event.key === 'ArrowUp'))
                || event.type === 'change')) {
            if (this.zone) {
                const target = event.target, countrySelectedValue = target.options[target.selectedIndex].value;
                this.loadCountryZonesByCountry(countrySelectedValue);
            }
        }
    }
    /**
     * Process ajax response and display error message or
     * hand data received to add zone option function
     */
    xhrReadyOnLoad(stateChanged) {
        const xhrResponse = stateChanged.target;
        if (xhrResponse.readyState === 4 && xhrResponse.status === 200) {
            const xhrResponseData = JSON.parse(xhrResponse.responseText);
            this.hideElement(this.zoneLoading);
            if (xhrResponseData.status === 'error' || xhrResponseData.data.length === 0) {
                this.showElement(this.zoneEmpty);
            }
            else {
                this.addZoneOptions(xhrResponseData.data);
            }
        }
        this.loading = false;
    }
    /**
     * Process data received with xhr response
     */
    addZoneOptions(options) {
        while (this.zone.length) {
            this.zone.removeChild(this.zone[0]);
        }
        options.forEach((option, index) => {
            this.zone.options[index] = new Option(option.label, option.value);
        });
        this.zone.disabled = false;
    }
    /**
     * Adds a preview information about file to upload in a label
     */
    uploadFile(event) {
        const upload = event.target;
        if (this.fileInformation !== null) {
            this.fileInformation.value = upload.value;
        }
    }
    /**
     * Handle remove image button clicked
     */
    removeFile() {
        if (this.removeImage !== null) {
            this.removeImage.value = '1';
            this.form.submit();
        }
    }
}
